import { gpActions } from './const/gp-actions.const';
import { gpPersonas } from './const/gp-personas.const';
import { GpWpStatus } from './enum/gp-wp-status.enum';
import { ViewRow } from './view-row.model';

const personaOrder = Array.from(gpPersonas.keys());
const actionOrder = Array.from(gpActions.keys());

export function gpSortValue(r: ViewRow, col: string, sortOrder: string): any {
    const nullVal =
        sortOrder === 'asc' ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
    switch (col) {
        case 'team':
            return r.name;
        case 'persona': {
            const idx = personaOrder.indexOf(r.personaType);
            return idx === -1 ? nullVal : idx;
        }
        case 'oa': {
            if (r.row.oaScore != null) {
                if (r.row.oaScore >= 1) return 3;
                if (r.row.oaScore > 0) return 2;
                return 1;
            }
            return nullVal;
        }
        case 'wp': {
            if (r.wpStatus === GpWpStatus.WIN) return 4;
            if (r.wpStatus === GpWpStatus.IMPROVE) return 3;
            if (r.wpStatus === GpWpStatus.NEW) return 2;
            if (r.wpStatus === GpWpStatus.DECLINE) return 1;
            return nullVal;
        }
        case 'nba': {
            const idx = actionOrder.indexOf(r.groupedAction?.actionType);
            return idx === -1 ? nullVal : gpActions.size - idx;
        }
        default:
            return 0;
    }
}

export function gpCompareRows(
    a: ViewRow,
    b: ViewRow,
    sortColumn: string,
    sortOrder: string,
): number {
    const va = gpSortValue(a, sortColumn, sortOrder);
    const vb = gpSortValue(b, sortColumn, sortOrder);
    const [fva, fvb] = sortOrder === 'asc' ? [va, vb] : [vb, va];
    if (typeof fva === 'string') return fva.localeCompare(fvb);
    const diff = fva - fvb;
    if (diff !== 0) return diff;
    return a.name.localeCompare(b.name);
}
